<script>
import { http } from '@/system/http';
import SurveyLogCreateModal from '@/system/Models/SurveyLog/SurveyLogCreateModal.vue';
import { escapeHtmlCharacters } from '@/system/helpers';

export default {
    props: {
        surveyRequestAnswer: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            isOpen: false,
            reason: '',
        };
    },

    methods: {
        escapeHtmlCharacters,
        destroy() {
            this.loading = true;

            http.post('/app/survey-request-answers/' + this.surveyRequestAnswer.id + '/destroy', {
                reason: this.reason,
            })
                .then(({ data }) => {
                    toastr.success(data.success);

                    window.location.reload();

                    this.isOpen = false;

                    this.loading = false;
                })
                .catch(({ error, errorBag }) => {
                    if (errorBag) {
                        this.$setErrorBag(errorBag);
                    }

                    this.loading = false;
                });
        },

        openToggled(newValue) {
            this.isOpen = newValue

            this.errors.clear()
        }
    },

    components: {
        SurveyLogCreateModal,
    },
};
</script>

<template>
    <div class="delete-survey-answer">
        <a href="#" @click.prevent="isOpen = true"><i class="fa fa-trash text-black"></i></a>

        <survey-log-create-modal
            :reason="reason"
            :is-open="isOpen"
            @reasonUpdated="newValue => (reason = newValue)"
            @openToggled="openToggled"
        >
            <template #title>
                {{ trans('surveys.delete_survey_answer_confirm_text') }}
            </template>

            <template #confirmation>
                <div v-sanitize-html="trans('surveys.delete_survey_request_answer_confirm', { survey_request_question: escapeHtmlCharacters(surveyRequestAnswer.question) })"/>
            </template>

            <template #footer>
                <div class="mt-6">
                    <ep-button @click="destroy" :loading="loading">
                        {{ trans('surveys.delete_survey_answer_confirm_text') }}
                    </ep-button>
                </div>
            </template>
        </survey-log-create-modal>
    </div>
</template>
